import { PartialTranslation } from '../translations';

export const lo: PartialTranslation = {
  newChat: 'ການສົນທະນາໃໝ່',
  search: 'ຊອກຫາ',
  user: 'ຜູ້ໃຊ້',
  settings: 'ການຕັ້ງຄ່າ',
  language: 'ພາສາ',
  getHelp: 'ຂໍຄວາມຊ່ວຍເຫຼືອ',
  viewAllPlans: 'ເບິ່ງແຜນການທັງໝົດ',
  learnMore: 'ຮຽນຮູ້ເພີ່ມເຕີມ',
  logOut: 'ອອກຈາກລະບົບ',
  chooseLanguage: 'ເລືອກພາສາ',
  chooseYourPreferredLanguage: 'ເລືອກພາສາທີ່ທ່ານຕ້ອງການ',
  searchLanguages: 'ຊອກຫາພາສາ...',
  autoDetect: 'ການກວດພົບອັດຕະໂນມັດ',
  noLanguagesFound: 'ບໍ່ພົບພາສາ',
  askAnything: 'ຖາມຫຍັງກໍໄດ້',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ສ່ວນຕົວ',
  freePlan: 'ແຜນການຟຣີ',
  current: 'ປັດຈຸບັນ',
  close: 'ປິດ',
  archive: 'ເກັບຮັກສາ',
  delete: 'ລົບ',
  confirmDelete: 'ທ່ານແນ່ໃຈແລ້ວບໍ່ທີ່ຈະລົບການສົນທະນານີ້?',
  confirmArchive: 'ທ່ານແນ່ໃຈແລ້ວບໍ່ທີ່ຈະເກັບຮັກສາການສົນທະນານີ້?',
  deleteCannotUndo: 'ການກະທຳນີ້ບໍ່ສາມາດຍົກເລີກໄດ້.',
  archiveCanFind: 'ທ່ານສາມາດຊອກຫາມັນໃນລາຍການເກັບຮັກສາຫຼັງຈາກເກັບຮັກສາແລ້ວ.',
  resources: 'ຊັບພະຍາກອນ',
  addResource: 'ເພີ່ມຊັບພະຍາກອນ',
  deleteResource: 'ລົບຊັບພະຍາກອນ',
  noMatchingResourcesFound: 'ບໍ່ພົບຊັບພະຍາກອນທີ່ຕົງກັນ',
  noResourcesAvailable: 'ບໍ່ມີຊັບພະຍາກອນທີ່ໃຊ້ໄດ້',
  hideResources: 'ເຊື່ອງຊັບພະຍາກອນ',
  showResources: 'ສະແດງຊັບພະຍາກອນ',
  typeMessage: 'ພິມຂໍ້ຄວາມ...',
  thinkingOptions: 'ທາງເລືອກການຄິດ',
  deleteFile: 'ລົບໄຟລ໌',
  clearSelection: 'ລຶບການເລືອກ',
  addAttachment: 'ເພີ່ມໄຟລ໌ແນບ',
  sendMessage: 'ສົ່ງຂໍ້ຄວາມ',
  deepInsight: 'ຄວາມເຂົ້າໃຈເລິກ · ການວິເຄາະຜິວໜ້າ',
  deepInsightDesc: 'ຄວາມເຂົ້າໃຈດ່ວນຂອງຈຸດສຳຄັນ',
  deepExploration: 'ການສຳຫຼວດເລິກ · ການວິເຄາະທີ່ສົມບູນ',
  deepExplorationDesc: 'ການຄົ້ນຄວ້າເລິກຫຼາຍມິຕິ',
  deepDeconstruction: 'ການລະລາຍເລິກ · ການໂຕ້ແຍ້ງແບບມີລະບົບ',
  deepDeconstructionDesc: 'ການວິເຄາະແບບກ້າວໜ້າເປັນຊັ້ນ',
  contractReview: 'ການກວດສອບສັນຍາ · ການກຳນົດຄວາມສ່ຽງ',
  contractReviewDesc: 'ການວິເຄາະຂໍ້ກຳນົດ ແລະ ການກວດສອບການປະຕິບັດຕາມ',
  textPolish: 'ການປັບປຸງຂໍ້ຄວາມ · ການສະແດງອອກແບບມືອາຊີບ',
  textPolishDesc: 'ການປັບປຸງພາສາ ແລະ ການປັບໂຄງສ້າງ',
  legalDocuments: 'ເອກະສານກົດໝາຍ · ການຮ່າງມາດຕະຖານ',
  legalDocumentsDesc: 'ການຂຽນເອກະສານກົດໝາຍແບບມືອາຊີບ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ເຂົ້າສູ່ລະບົບ',
  register: 'ລົງທະບຽນ',
  welcomeBack: 'ຍິນດີຕ້ອນຮັບສູ່ LawHelper',
  loginSubtitle: 'ຜູ້ຊ່ວຍຄົ້ນຄວ້າກົດໝາຍ AI ຂອງທ່ານ',
  continueWithGoogle: 'ດຳເນີນການຕໍ່ກັບ Google',
  continueWithMicrosoft: 'ດຳເນີນການຕໍ່ກັບ Microsoft',
  continueWithWeChat: 'ດຳເນີນການຕໍ່ກັບ WeChat',
  orContinueWith: 'ຫຼືດຳເນີນການຕໍ່ກັບ',
  emailTab: 'ອີເມວ',
  phoneTab: 'ໂທລະສັບ',
  emailPlaceholder: 'ໃສ່ອີເມວຂອງທ່ານ',
  phonePlaceholder: 'ໃສ່ເບີໂທລະສັບ',
  codePlaceholder: 'ໃສ່ລະຫັດ 6 ຕົວເລກ',
  sending: 'ກຳລັງສົ່ງ...',
  verifying: 'ກຳລັງຢືນຢັນ...',
  verify: 'ຢືນຢັນ',
  sendMagicLink: 'ສົ່ງລິ້ງວິເສດ',
  getVerificationCode: 'ຮັບລະຫັດ',
  resendCode: 'ສົ່ງລະຫັດໃໝ່',
  resendIn: 'ສົ່ງໃໝ່',
  magicLinkSent: 'ລິ້ງວິເສດຖືກສົ່ງໄປອີເມວຂອງທ່ານ',
  magicLinkHint: 'ພວກເຮົາຈະສົ່ງລິ້ງທີ່ປອດໄພໄປຫາອີເມວຂອງທ່ານ',
  otpSent: 'ລະຫັດຢືນຢັນຖືກສົ່ງແລ້ວ',
  agreeToTerms: 'ໂດຍການດຳເນີນການຕໍ່, ທ່ານເຫັນດີກັບ',
  privacyPolicy: 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
  termsOfService: 'ເງື່ອນໄຂການບໍລິການ',
  and: 'ແລະ',
  privacyTitle: 'ຄວາມເປັນສ່ວນຕົວຂອງທ່ານມີຄວາມສຳຄັນ',
  privacyIntro: 'ພວກເຮົາໃຊ້ຄຸກກີ້ ແລະເຕັກໂນໂລຊີທີ່ຄ້າຍຄືກັນເພື່ອໃຫ້ປະສົບການທີ່ດີທີ່ສຸດ.',
  essentialCookies: 'ຄຸກກີ້ທີ່ຈຳເປັນ',
  essentialDesc: 'ຕ້ອງການສຳລັບເວັບໄຊທ໌ເຮັດວຽກ',
  analyticsCookies: 'ຄຸກກີ້ວິເຄາະ',
  analyticsDesc: 'ຊ່ວຍພວກເຮົາປັບປຸງການບໍລິການ',
  marketingCookies: 'ຄຸກກີ້ການຕະຫຼາດ',
  marketingDesc: 'ໃຊ້ສຳລັບເນື້ອຫາສ່ວນບຸກຄົນ',
  acceptAll: 'ຍອມຮັບທັງໝົດ',
  essentialOnly: 'ຈຳເປັນເທົ່ານັ້ນ',
  customize: 'ປັບແຕ່ງ',
  savePreferences: 'ບັນທຶກການຕັ້ງຄ່າ',
  back: 'ກັບຄືນ',
  readPrivacyPolicy: 'ອ່ານນະໂຍບາຍຄວາມເປັນສ່ວນຕົວຂອງພວກເຮົາ',
  cookiePolicy: 'ນະໂຍບາຍຄຸກກີ້',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'ການກວດສອບ AI',
  aiDraft: 'ຮ່າງ AI',
  smartAssistant: 'ແມ່ແບບ',

  // 知识库搜索
  enableKnowledgeSearch: 'ເປີດໃຊ້ການຄົ້ນຫາ',
  knowledgeSearchDesc: 'AI ຄົ້ນຫາໃນເອກະສານຂອງທ່ານ',
  clickToDisable: 'ປິດ',
  clickToEnable: 'ເປີດ',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ຄຳຕອບໄວ',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'ຍົກເລີກ',
  library: 'ຫ້ອງສະຫມຸດ',
  filterAll: 'ທັງໝົດ',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ກຳລັງຄິດ...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'ທົ່ວໄປ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'ເກີ່ຢວກັບ',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ຜູ້ຊ່ວຍເອກະສານສະຫຼາດ',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'ຂໍ້ຜິດພາດ',
  unknownError: 'Unknown error',
  file: 'ໄຟລ໌',
  loading: 'ກຳລັງໂຫລດ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'ວິເຄາະ AI',
};
